import styled from 'styled-components';
import { InputChipMixin } from '../../mixins/components/InputChipMixin';
export var StyledInputChip = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledInputChip",
  componentId: "c11n-8-111-1__sc-tpxe8j-0"
})(["", ""], InputChipMixin);